export default "__VITE_ASSET__kNn1IPKy__"